import { Dropdown, MenuProps } from 'antd';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DownOutlined } from '@ant-design/icons';
import { SortRefrigeratorBy } from '@common/enums';

import './refrigerator.scss';

interface SortRefrigeratorProps {
    sortBy?: SortRefrigeratorBy;
    setSortBy: (sortBy: SortRefrigeratorBy | undefined) => void;
}

export const SortRefrigerator = ({ sortBy, setSortBy }: SortRefrigeratorProps): JSX.Element => {
    const { t } = useTranslation();

    const sortByTitle = useMemo<string>(() => {
        switch (sortBy) {
            case SortRefrigeratorBy.LowToHigh:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.PRICE_LOW_TO_HIGH')}`;
            case SortRefrigeratorBy.HighToLow:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.PRICE_HIGH_TO_LOW')}`;
            case SortRefrigeratorBy.NameAZ:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.NAME_A_Z')}`;
            case SortRefrigeratorBy.NameZA:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.NAME_Z_A')}`;
            case SortRefrigeratorBy.TrendingNow:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.TRENDING_NOW')}`;
            default:
                return t('COMMON.SORT_BY');
        }
    }, [sortBy]);

    function onSelectionChange(key: SortRefrigeratorBy | undefined) {
        // deselecting
        if (sortBy === Number(key)) {
            setSortBy(undefined);
            key = undefined;
        } else {
            setSortBy(Number(key));
        }
    }

    const dropdownItems: MenuProps['items'] = [
        {
            key: SortRefrigeratorBy.TrendingNow,
            label: (
                <div
                    className={classNames({
                        selected: sortBy === SortRefrigeratorBy.TrendingNow,
                    })}
                >
                    {t('SCROLLABLE_AREA.COLOR.TRENDING_NOW')}
                </div>
            ),
        },
        {
            key: SortRefrigeratorBy.LowToHigh,
            label: (
                <div
                    className={classNames({
                        selected: sortBy === SortRefrigeratorBy.LowToHigh,
                    })}
                >
                    <span>{t('SCROLLABLE_AREA.COLOR.PRICE_LOW_TO_HIGH')}</span>
                </div>
            ),
        },
        {
            key: SortRefrigeratorBy.HighToLow,
            label: (
                <div
                    className={classNames({
                        selected: sortBy === SortRefrigeratorBy.HighToLow,
                    })}
                >
                    {t('SCROLLABLE_AREA.COLOR.PRICE_HIGH_TO_LOW')}
                </div>
            ),
        },
        {
            key: SortRefrigeratorBy.NameAZ,
            label: (
                <div
                    className={classNames({
                        selected: sortBy === SortRefrigeratorBy.NameAZ,
                    })}
                >
                    {t('SCROLLABLE_AREA.COLOR.NAME_A_Z')}
                </div>
            ),
        },
        {
            key: SortRefrigeratorBy.NameZA,
            label: (
                <div
                    className={classNames({
                        selected: sortBy === SortRefrigeratorBy.NameZA,
                    })}
                >
                    {t('SCROLLABLE_AREA.COLOR.NAME_Z_A')}
                </div>
            ),
        },
    ];

    return (
        <Dropdown
            menu={{
                onClick: (e) => onSelectionChange(e.key as unknown as SortRefrigeratorBy),
                items: dropdownItems,
            }}
        >
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                {sortByTitle} <DownOutlined />
            </a>
        </Dropdown>
    );
};
